import React from 'react';
import Container from 'react-bootstrap/Container';
import { Colors } from '_styles';

// navigation bar for confirm booking page
const ConfirmNavigator = (props) => {
    return (
        <>
            <Container style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }}>
                <p style={{ fontSize: 28, fontWeight: '200', color: Colors.PRM_LIGHT_BLUE, textDecoration: (props.page == 'booking') ? 'underline' : 'none', cursor: 'pointer' }} onClick={() => props.setPage('booking')}>Booking</p>
                <p style={{ fontSize: 28, fontWeight: '200', color: Colors.PRM_LIGHT_BLUE, textDecoration: (props.page == 'contact') ? 'underline' : 'none', cursor: 'pointer' }} onClick={() => props.setPage('contact')}>Contact</p>
            </Container>
        </>
    );
};


export default ConfirmNavigator;
